(function (window, document) {
    if (document.querySelector('.newslist') !== null) {
        const categorySelectElement = document.querySelector('.newslist .newslist-newsselect');
        const categorySelectElementMobil = document.querySelector('.newslist .newslist-filterselect');
        const columns = parseInt(document.querySelector('.newslist').getAttribute('data-columns'));
        let offset = parseInt(document.querySelector('.newslist').getAttribute('data-offset'));
        const limit = parseInt(document.querySelector('.newslist').getAttribute('data-limit'));
        const endlessScroll = parseInt(document.querySelector('.newslist').getAttribute('data-endlessscroll')) === 1;
        let preFilteredCategories = document.querySelector('.newslist').getAttribute('data-prefilteredcategories');
        let loading = false;

        /**
         * Load news
         *
         * @param categoryId
         */
        const loadNews = (categoryId) => {
            if (loading) {
                return;
            }
            loading = true;

            let category = categoryId ? categoryId : '';
            let url = window._AVENCY_BASE_actions.newsList;
            url += category !== '' ? '&category=' + category : '';

            if (category === '') {
                url += preFilteredCategories !== '' ? '&preFilteredCategories=' + preFilteredCategories : '';
            }
            url += '&columns=' + columns;
            url += '&offset=' + offset;
            url += '&limit=' + limit;

            const request = new XMLHttpRequest();
            request.open('GET', url, true);
            request.onload = function () {
                if (this.status >= 200 && this.status < 400 && this.response !== '') {
                    if (endlessScroll && offset > 0) {
                        var newDom = document.createElement('div');
                        newDom.innerHTML = this.response;
                        document.querySelector('.newslist .newslist-listing').appendChild(newDom);
                    } else {
                        document.querySelector('.newslist .newslist-listing').innerHTML = this.response;
                    }
                    loading = false;
                    offset += limit;
                }
            };
            request.send();
        }

        /**
         * Check if news bottom is in viewport
         *
         * @returns {boolean|boolean}
         */
        const isInViewport = () => {
            const endlessScrollElement = document.querySelector('.newslist .newslist-endlessscroll');
            const bounding = endlessScrollElement.getBoundingClientRect();
            return (
                bounding.top >= 0 &&
                bounding.left >= 0 &&
                bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }

        // Load first batch of news
        loadNews();

        if (categorySelectElement !== null) {
            // Add active class to preFiltered categories
            if (preFilteredCategories !== '') {
                const preFilteredElements = preFilteredCategories.split(',');

                Array.prototype.forEach.call(preFilteredElements, (preFilteredCategory) => {
                    const preFilteredElement = categorySelectElement.querySelector('[data-categoryid="' + preFilteredCategory + '"]');
                    preFilteredElement.classList.add('active');
                });
            }

            // click event
            categorySelectElement.addEventListener('click', (e) => {
                const activeElement = $(e.target).closest('li');
                const categoryId = activeElement[0].dataset.categoryid;
                const filterOptions = categorySelectElement.querySelectorAll('li');

                preFilteredCategories = '';
                Array.prototype.forEach.call(filterOptions, (el) => {
                    el.classList.remove('active');
                });
                activeElement[0].classList.add('active');

                offset = 0;
                loading = false;
                loadNews(categoryId);
            }, {passive: true});
        }

        if (categorySelectElementMobil !== null) {
            // Add active class to preFiltered categories
            if (preFilteredCategories !== '') {
                const mobileFilter = categorySelectElementMobil.parentNode.querySelector('.select-items').querySelectorAll('div');
                Array.prototype.forEach.call(mobileFilter, (el) => {
                    el.classList.remove('same-as-selected');
                });

                const mobilePreFilteredElements = preFilteredCategories.split(',');
                Array.prototype.forEach.call(mobilePreFilteredElements, (mobilePreFilteredCategory) => {
                    const mobilePreFilteredElement = categorySelectElementMobil.parentNode.querySelector('.select-items').querySelector('[value="' + mobilePreFilteredCategory + '"]');
                    mobilePreFilteredElement.classList.add('same-as-selected');
                });
            }

            // Change event
            categorySelectElementMobil.addEventListener('change', (e) => {
                const activeElement = $(e.target).parent().find('.same-as-selected');
                const categoryId = activeElement[0].getAttribute('value');

                if (categorySelectElement !== null) {
                    const filterOptions = categorySelectElement.querySelectorAll('li');

                    preFilteredCategories = '';
                    Array.prototype.forEach.call(filterOptions, (el) => {
                        el.classList.remove('active');

                        if(el.innerText === activeElement[0].innerText) {
                            el.classList.add('active');
                        }
                    });
                }

                offset = 0;
                loading = false;
                loadNews(categoryId);
            }, {passive: true});
        }

        if (endlessScroll) {
            window.addEventListener('scroll', () => {
                if (isInViewport()) {
                    loadNews();
                }
            }, {passive: true});
        }
    }
})(window, document);
